import React from 'react';
import PropTypes from 'prop-types';
import TestCard from './TestCard';

const TestGrid = ({ 
  tests, 
  onStartTest, 
  onPayment, 
  variant = 'detailed',
  loading = false,
  error = null
}) => {
  // Group tests by name for level toggling
  const groupTestsByName = (testList) => {
    const grouped = {};
    testList.forEach(test => {
      const name = test.name || 'Unknown Test';
      if (!grouped[name]) {
        grouped[name] = [];
      }
      grouped[name].push(test);
    });
    return Object.values(grouped);
  };

  const groupedTests = groupTestsByName(tests || []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 'var(--spacing-2xl)' }}>
        <div className="loading-spinner"></div>
        <p>Loading tests...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: 'var(--spacing-2xl)' }}>
        <p style={{ color: 'var(--error)' }}>Error loading tests: {error}</p>
      </div>
    );
  }

  if (!tests || tests.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 'var(--spacing-2xl)' }}>
        <p style={{ color: 'var(--text-secondary)' }}>No tests available.</p>
      </div>
    );
  }

  if (variant === 'detailed') {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 'var(--spacing-lg)',
        marginBottom: 'var(--spacing-2xl)'
      }}>
        {groupedTests.map((testGroup, index) => (
          <TestCard
            key={`${testGroup[0].testId}-${index}`}
            test={testGroup[0]}
            tests={testGroup}
            onStartTest={onStartTest}
            onPayment={onPayment}
            variant="detailed"
          />
        ))}
      </div>
    );
  }

  // Compact grid layout for my-tests page
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: 'var(--spacing-lg)'
    }}>
      {groupedTests.map((testGroup, index) => (
        <TestCard
          key={`${testGroup[0].testId}-${index}`}
          test={testGroup[0]}
          tests={testGroup}
          onStartTest={onStartTest}
          onPayment={onPayment}
          variant="compact"
        />
      ))}
    </div>
  );
};

TestGrid.propTypes = {
  tests: PropTypes.arrayOf(PropTypes.shape({
    testId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    category: PropTypes.string,
    status: PropTypes.string,
    price: PropTypes.number,
    suggestedTimeInMinutes: PropTypes.number,
    numCorrectAnswers: PropTypes.number,
    numQuestions: PropTypes.number,
    difficulty: PropTypes.string,
    level: PropTypes.string
  })),
  onStartTest: PropTypes.func.isRequired,
  onPayment: PropTypes.func,
  variant: PropTypes.oneOf(['compact', 'detailed']),
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default TestGrid; 